import React from 'react'
import {FONT_FAMILY_LIST} from "../../../../common/constants/designer.constant";
import PreviewFontFamily from "./preview-font-family";
import {FLIP_DIRECTION_KEY, FLIP_DIRECTION_LIST} from "../../../constants/design.constant";

const EditFlipDetails = ({item, handleFlipDetailsChanges}) => {

    const handleFlipDirectionChange = (flipDirection) => {
        const event = {
            target: {
                name: 'flip',
                value: flipDirection,
                type: 'text'
            }
        };

        handleFlipDetailsChanges(event, item);
    }

    return (
        <>

            <div className="flex justify-between">
                <div className="mb-2 ml-2 field-label">
                    Flip Direction
                </div>
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <button
                            className="button-outline-gray px-3 py-2 mr-2"
                            onClick={(event) => {
                                handleFlipDirectionChange(FLIP_DIRECTION_KEY.VERTICAL);
                            }}>
                            Vertical
                        </button>

                        <button
                            className="button-outline-gray px-3 py-2"
                            onClick={(event) => {
                                handleFlipDirectionChange(FLIP_DIRECTION_KEY.HORIZONTAL);
                            }}>
                            Horizontal
                        </button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditFlipDetails
